// Copied from DealerFlow 360 (dealerflow360/web/src/shared/payments/cardToken.ts); spec references are DF360's.
import { ACCEPT_LOAD_FAILED, AcceptJsError, acceptMessageText, type AcceptOpaqueData } from './acceptJs';
import type { CardBilling } from './cardValidation';

/**
 * A typed card as a charge or an AutoPay schedule sends it (R25): Accept.js's single-use token with the name and
 * billing address, trimmed, the state upper-cased. Never the card number, expiration or CVV.
 */
export function tokenMethod(token: AcceptOpaqueData, billing: CardBilling) {
  return {
    kind: 'token' as const,
    dataDescriptor: token.dataDescriptor,
    dataValue: token.dataValue,
    nameOnAccount: billing.nameOnCard.trim(),
    billingStreet: billing.street.trim(),
    billingCity: billing.city.trim(),
    billingState: billing.state.trim().toUpperCase(),
    billingZip: billing.zip.trim(),
  };
}

/** Why the card couldn't be tokenized: Authorize.Net's own messages, else Accept.js's failure, else R24a's. */
export function tokenizeErrorText(error: unknown): string {
  if (!(error instanceof AcceptJsError)) return ACCEPT_LOAD_FAILED;
  return (error.messages.length ? acceptMessageText(error.messages) : [error.message]).join(' ');
}
